import { useEffect, useState } from "react";
import { storedLocale } from "../../../../Authentication/util";
import { useAppSelector } from "../../../../../store";
import { useGetFaaTrackingQuery } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import type { FaaTrackingResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";
import { TrendEnum } from "../../../../../common/leaf/LeafTrendIndicator/LeafTrendIndicator";
import { QUALIFICATION_STATUS } from "../../../../../common/enums/incentive-enums";

const faaTrackingInitial: FaaTrackingResponse = {
  faaTracking: {
    showFaa: false,
    routeId: "",
    dbrStatus: QUALIFICATION_STATUS.NOT_TRACKING,
    foundersPlatinumLegs: { actual: 0, formatted: "0", moMTrend: { difference: 0, trend: TrendEnum.EQUAL } },
    faaPoints: { actual: 0, formatted: "0", moMTrend: { difference: 0, trend: TrendEnum.EQUAL } },
    faaMultiplier: { actual: 0, formatted: "0" },
    superLegs: { actual: 0, formatted: "0" },
    trackingBonus: { actual: 0, formatted: "0" },
    lastMonthProcessed: 0,
    disableTile: false,
  },
  callResults: [],
  error: null,
};

export const FetchFaaTrackingData = (period: string) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetFaaTrackingQuery({
    aff: user.aff,
    abo: user.abo,
    period,
    isoCountryCode: user.isoCountryCode,
    locale: storedLocale(),
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [faaTrackingData, setFaaTrackingData] = useState<FaaTrackingResponse>(faaTrackingInitial);

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setFaaTrackingData(payloadData);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, faaTrackingData, errorStatus, refetch };
};
